/**
 * @description: 存储token以及uid的方法  这里用到的是 sessionStorage 会话缓存，当用户关闭浏览器窗口后，数据就会被删除
 * @author: Jsj
 * @Compile：2021-11-26 13：00
 * @update: Jsj(2021-3-10 13：00)
 */

const TokenKey = "token"; // 定义好公共的 key token 名
const Uid = "uid"; // 定义好公共的 key uid 名
const MenuList = "bbholiday_menuList"; // 定义好公共的 key menuList 名
// 需要cooke存再找
export function get_token() {
  return sessionStorage.getItem(TokenKey);
}

export function set_token(token) {
  return sessionStorage.setItem(TokenKey, token);
}

export function remove_token() {
  return sessionStorage.removeItems(TokenKey);
}

export function get_uid() {
  return sessionStorage.getItem(Uid);
}

export function set_uid(uid) {
  return sessionStorage.setItem(Uid, uid);
}

export function remove_uid() {
  return sessionStorage.removeItems(Uid);
}

export function get_menu_list() {
  return sessionStorage.getItem(MenuList);
}

export function set_menu_list(menuList) {
  return sessionStorage.setItem(MenuList, menuList);
}

export function remove_menu_list() {
  return sessionStorage.removeItems(MenuList);
}
